import React, { useState, useEffect } from "react";
import Drawer from "Common/Components/Drawer";
import { X } from "lucide-react";
import Segment from "./Segment";
import _ from "lodash";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import callApi from "Common/utils/apiCaller";
import Button from "Common/Components/ButtonComponent/Button";

const SegmentOrderModal = ({
  isVisible,
  onClose,
  pageId,
  pageView,
  getSegmentData,
  loader,
  setLoader,
}) => {
  useEffect(() => {
    let newOrder = {};
    pageView?.page_order.forEach((item) => {
      newOrder[item?.segment_id] = item.order;
    });
    setPageOrder(pageView?.page_order);
    setOriginalPageOrder(newOrder);
  }, [pageView]);

  const [pageOrder, setPageOrder] = useState(pageView?.page_order);

  const [originalPageOrder, setOriginalPageOrder] = useState({});

  const moveCardUp = (currentIndex) => {
    let oldPageOrder = [...pageOrder];
    if (currentIndex > 0) {
      // Swap current element with the one above it
      const temp = oldPageOrder[currentIndex];
      oldPageOrder[currentIndex] = oldPageOrder[currentIndex - 1];
      oldPageOrder[currentIndex - 1] = temp;
    }
    // Update order numbers
    const newPageOrder = oldPageOrder.map((item, index) => {
      item.order = index + 1;
      return item;
    });
    setPageOrder(newPageOrder);
  };

  const moveCardDown = (currentIndex) => {
    let oldPageOrder = [...pageOrder];
    if (currentIndex < oldPageOrder.length - 1) {
      // Swap current element with the one below it
      const temp = oldPageOrder[currentIndex];
      oldPageOrder[currentIndex] = oldPageOrder[currentIndex + 1];
      oldPageOrder[currentIndex + 1] = temp;
    }
    // Update order numbers
    const newPageOrder = oldPageOrder.map((item, index) => {
      item.order = index + 1;
      return item;
    });
    setPageOrder(newPageOrder);
  };

  const handleSaveOrder = async () => {
    let input = pageOrder.map((item, index) => {
      return {
        segment_id: item.segment_id,
        order: item.order,
      };
    });

    let res = await callApi(`v1/page/${pageId}/swap-order`, "post", {
      segmentOrders: input,
    });
    if (res.status === "Success") {
      setLoader(!loader);
      onClose();
    }
  };

  // const moveCard = (dragIndex, hoverIndex, dragRank, hoverRank, isDragging) => {
  //     let oldPageOrder = [...pageOrder];
  //     const dragSegmentArray = oldPageOrder.slice(dragIndex, dragIndex + 1);

  //     let newPageOrder = [];
  //     if (dragIndex < hoverIndex) {
  //         let preArray = oldPageOrder.slice(0, dragIndex);
  //         let middleArray = oldPageOrder.slice(dragIndex + 1, hoverIndex + 1);
  //         let rightArray = oldPageOrder.slice(hoverIndex + 1, oldPageOrder.length);
  //         newPageOrder = preArray.concat(middleArray, dragSegmentArray, rightArray);
  //     } else if (dragIndex > hoverIndex) {
  //         let preArray = oldPageOrder.slice(0, hoverIndex);
  //         let middleArray = oldPageOrder.slice(hoverIndex, dragIndex);
  //         let rightArray = oldPageOrder.slice(dragIndex + 1, oldPageOrder.length);
  //         newPageOrder = preArray.concat(dragSegmentArray, middleArray, rightArray);
  //     }
  //     newPageOrder = newPageOrder.map((img, index) => {
  //         img.order = index + 1;
  //         return img;
  //     });
  //     if (dragIndex !== hoverIndex) {
  //         setPageOrder(newPageOrder);
  //     }
  // };

  return (
    <Drawer
      show={isVisible}
      onHide={onClose}
      id="drawerEnd"
      drawer-end="true"
      className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
    >
      <Drawer.Header
        className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
        closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
      >
        <div className="flex items-center justify-between w-full">
          <Drawer.Title className="text-15">{"Select Order"}</Drawer.Title>
          <div className="flex items-center gap-4">
            <button
              onClick={() => handleSaveOrder()}
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              Save Order
            </button>
            <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
          </div>
        </div>
      </Drawer.Header>
      <Drawer.Body className="h-full p-4 overflow-y-auto">
        {/* <DndProvider backend={HTML5Backend}> */}
        <div className="grid grid-cols-12 gap-x-5">
          {pageOrder?.map((item, index) => (
            <div key={item._id} className="col-span-12">
              <Segment
                originalPageOrder={originalPageOrder}
                moveCardUp={moveCardUp}
                moveCardDown={moveCardDown}
                segment_type={item.segment_type}
                segment_id={item.segment_id}
                index={index}
                order={item.order}
                totalLength={pageOrder?.length}
                data={getSegmentData(item)}
              />
            </div>
          ))}
        </div>
        {/* </DndProvider> */}
      </Drawer.Body>
    </Drawer>
  );
};

export default SegmentOrderModal;
